export default function () {
	Array.from(document.querySelectorAll('[data-copy-text]')).forEach((elem) => {
		elem.addEventListener('click', () => {
			if (!document.hasFocus()) {
				window.focus();
			}

			navigator.clipboard.writeText(elem.dataset.copyText).then(() => {
				if (elem.dataset.showAfterCopy) {
					elem.style.display = 'none';
					Array.from(document.querySelectorAll(elem.dataset.showAfterCopy)).forEach(
						(e) => (e.style.display = elem.dataset.showAfterCopyType)
					);
				}
			});
		});
	});
}
